import React, {useState,useEffect, useContext, useCallback} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import { AuthContext } from "../../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../../config/api";

const Seguimiento = () => {

  const navigate = useNavigate();
  const { id } = useParams();
  const { authFetch } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
    const seguimientoUrl = searchParams.get("seguimiento");

  // ==========================
  // INFORMACIÓN GENERAL
  // ==========================

    const [seguimientos, setSeguimientos] = useState([]);
    const [seguimientoSeleccionado, setSeguimientoSeleccionado] = useState(null);
    const [idSeguimiento, setIdSeguimiento] = useState(null);
    const [loading, setLoading] = useState(true);

  // ==========================
  // INDICADORES
  // ==========================

  const [indicadores,setIndicadores] = useState([]);

  // ==========================
  // MENSAJES
  // ==========================

  const [error,setError] = useState("");
  const [success,setSuccess] = useState("");
  const formatearMesAnio = (fecha) => {

    if (!fecha) return "";
    const [anio, mes] = fecha.split("-");
    const meses = [

        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"

    ];

    return `${meses[parseInt(mes) - 1]} de ${anio}`;

};

// ==========================
// CREAR SEGUIMIENTO
// ==========================

const [mes,setMes] = useState("");
const [anio,setAnio] = useState(new Date().getFullYear());
  
  // ==========================
  // CARGAR SEGUIMIENTO
  // ==========================
const loadSeguimiento = useCallback(async () => {

    setLoading(true);
    setError("");

    try {

        const res = await authFetch(
            `${ENDPOINTS.get_seguimiento}?id=${id}`
        );

        if (res.success) {

            const lista = res.data || [];

            setSeguimientos(lista);

            if (lista.length > 0) {

                let seguimientoInicial = lista[0];

                // Si viene un seguimiento específico desde Seguimiento General
                if (seguimientoUrl) {

                    const encontrado = lista.find(
                        item => String(item.id) === String(seguimientoUrl)
                    );

                    if (encontrado) {
                        seguimientoInicial = encontrado;
                    }
                }

                setSeguimientoSeleccionado(seguimientoInicial);
                setIdSeguimiento(seguimientoInicial.id);

            } else {

                setSeguimientoSeleccionado(null);
                setIdSeguimiento(null);

            }

        } else {

            setSeguimientos([]);
            setSeguimientoSeleccionado(null);
            setIdSeguimiento(null);

            setError(
                res.message ||
                "No fue posible cargar los seguimientos."
            );

        }

    } catch (error) {

        console.error(error);

        setSeguimientos([]);
        setSeguimientoSeleccionado(null);
        setIdSeguimiento(null);

        setError(
            "Error al consultar los seguimientos."
        );

    } finally {

        setLoading(false);

    }

}, [id, authFetch, seguimientoUrl]);
  // ==========================
  // CARGAR INDICADORES
  // ==========================

const loadIndicadores = useCallback(async () => {

    try {

      if (!idSeguimiento) {
          setIndicadores([]);
          setLoading(false);
          return;
      }

        const res = await authFetch(`${ENDPOINTS.get_indicadores}?id_seguimiento_uno=${idSeguimiento}`);

      if (res.success) {

        setIndicadores(
          res.data || []
        );

      } else {
        setIndicadores([]);
      }

    } catch (error) {
      console.error(error);
      setIndicadores([]);
    }
    setLoading(false);

}, [idSeguimiento, authFetch]);

  // ==========================
  // INICIALIZAR
  // ==========================
useEffect(() => {

    loadSeguimiento();
}, [loadSeguimiento]);



useEffect(() => {

    if (idSeguimiento) {

        loadIndicadores();

    } else {

        setIndicadores([]);
        setLoading(false);

    }

}, [idSeguimiento, loadIndicadores]);

// ==========================
// CAMBIAR VALOR DE UNA CELDA
// ==========================

const handleChange = (index,field,value) => {

    const nuevos = [...indicadores];
    nuevos[index][field] = value;

    const tipo = nuevos[index].tipo;
    const referencia = Number(nuevos[index].dato_referencia);
    const datoMes = Number(nuevos[index].dato_mes);

    // ==========================
    // CALCULAR RESULTADO %
    // ==========================

    if (tipo === "%") {

        if (referencia > 0) {

            nuevos[index].resultado = Math.round(
                (datoMes / referencia) * 100
            );

        } else {
            // Si la referencia es 0 o está vacía
            nuevos[index].resultado = 0;
        }

    }

    // ==========================
    // CALCULAR RESULTADO #
    // ==========================
    if (tipo === "#") {
        if (referencia === 0) {
            nuevos[index].resultado = datoMes;
        } else {
            nuevos[index].resultado = referencia - datoMes;
        }
    }

    setIndicadores(nuevos);
};

  // ==========================
  // AGREGAR FILA
  // ==========================

  const agregarFila = () => {

    setIndicadores([...indicadores,

      {
        indicador: "",
        formula: "",
        dato_referencia: "",
        dato_mes: "",
        tipo: "",
        resultado: ""
      }

    ]);

  };

  // ==========================
  // ELIMINAR FILA
  // ==========================

  const eliminarFila = (index) => {

    const nuevosIndicadores = indicadores.filter((_, i) => i !== index);

    setIndicadores(nuevosIndicadores);

  };

  // ==========================
  // GUARDAR TODOS
  // ==========================

  const guardarIndicadores = async () => {

    setError("");
    setSuccess("");

    // ==========================
    // VALIDAR INDICADORES
    // ==========================

    for (let i = 0; i < indicadores.length; i++) {
        const item = indicadores[i];

        if (!item.indicador?.trim()) {
            setError(`El indicador de la fila ${i + 1} es obligatorio.`);
            return;
        }

        if (!item.formula?.trim()) {
            setError(`La fórmula de la fila ${i + 1} es obligatoria.`);
            return;
        }

        if (
            item.dato_referencia === "" ||
            item.dato_referencia === null ||
            item.dato_referencia === undefined
        ) {
            setError(`El dato de referencia de la fila ${i + 1} es obligatorio.`);
            return;
        }

        if (
            item.dato_mes === "" ||
            item.dato_mes === null ||
            item.dato_mes === undefined
        ) {
            setError(`El dato del mes de la fila ${i + 1} es obligatorio.`);
            return;
        }

        if (!item.tipo) {
            setError(`Debe seleccionar el tipo de la fila ${i + 1}.`);
            return;
        }
    }

    try {

      const res = await authFetch(ENDPOINTS.save_indicadores,

        {
          method: "POST",
          body: JSON.stringify({
            id_seguimiento_uno: idSeguimiento,
            indicadores
          })
        }

      );

     if (res.success) {
    setSuccess(res.message);
    await loadIndicadores();

} else {

    setError(res.message);

}

    } catch (error) {

      console.error(error);
      setError(
        "Error al guardar los indicadores."

      );

    }

  };

  // ==========================
    // CREAR SEGUIMIENTO
    // ==========================

    const crearSeguimiento = async () => {

        setError("");
        setSuccess("");
        if (!mes) {

            setError(

                "Debe seleccionar el mes."

            );

            return;

        }

        try {

            const res = await authFetch(ENDPOINTS.create_seguimiento,

                {

                    method: "POST",
                    body: JSON.stringify({
                        id_informacion_general: id,
                        mes,
                        anio

                    })

                }

            );

      if (res.success) {

            setSuccess(res.message);
            await loadSeguimiento();

        } else {
            setError(res.message);
        }

        }

        catch (error) {

            console.error(error);
            setError(
                "Error al crear el seguimiento."
            );

        }

    };

    // CREAR SEGUIMIENTO MES
    const crearSeguimientoMes = async () => {

    if (!idSeguimiento) {
        setError("No hay un seguimiento seleccionado.");
        return;
    }

    if (!mes || !anio) {
        setError("Debe seleccionar el mes y el año.");
        return;
    }

    try {

        setLoading(true);
        setError("");
        setSuccess("");

        const res = await authFetch(
            ENDPOINTS.create_seguimiento_mes,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id_seguimiento_uno: idSeguimiento,
                    mes: Number(mes),
                    anio: Number(anio)
                })
            }
        );

        if (res.success) {

            setSuccess(
                "Seguimiento mensual creado correctamente."
            );

            // Recargar todos los meses
            await loadSeguimiento();

        } else {

            setError(
                res.message ||
                "No fue posible crear el seguimiento mensual."
            );

        }

    } catch (error) {

        console.error(error);

        setError(
            "Error al crear el seguimiento mensual."
        );

    } finally {

        setLoading(false);

    }
};

    if (loading) {

    return (

      <div className="text-center mt-5">

        Cargando...

      </div>

    );

  }

  return (

    <div className="container mt-4">

      {/* ==========================
          HEADER
      ========================== */}

      <div className="d-flex justify-content-between align-items-center mb-4">

        <h3>Seguimiento Técnico I</h3>

        <button className="btn btn-outline-pink" onClick={() => navigate(-1)}>

          <i className="bi bi-arrow-left me-2"></i>
          Volver

        </button>

      </div>

    {/* ==========================
        SELECCIONAR SEGUIMIENTO
    ========================== */}

    {seguimientos.length > 0 && (

        <div className="card mb-4">

            <div className="card-header">
                Seguimiento técnico
            </div>

            <div className="card-body">

                <div className="row">

                    <div className="col-md-5">

                        <label className="form-label">
                            Mes del seguimiento
                        </label>

                        <select
                            className="form-select"
                            value={idSeguimiento || ""}
                            onChange={(e) => {

                                const seleccionado =
                                    seguimientos.find(
                                        item =>
                                            String(item.id) === e.target.value
                                    );

                                if (seleccionado) {

                                    setSeguimientoSeleccionado(
                                        seleccionado
                                    );

                                    setIdSeguimiento(
                                        seleccionado.id
                                    );

                                }

                            }}
                        >

                            {seguimientos.map((item) => (

                                <option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {formatearMesAnio(item.mes_año)}
                                </option>

                            ))}

                        </select>

                    </div>

                </div>

            </div>

        </div>

    )}

    {seguimientos.length > 0 && (

    <div className="card mb-4">

        <div className="card-header">
            Crear nuevo seguimiento mensual
        </div>

        <div className="card-body">

            <div className="row">

                <div className="col-md-4">

                    <label className="form-label">
                        Mes
                    </label>

                    <select
                        className="form-select"
                        value={mes}
                        onChange={(e) =>
                            setMes(e.target.value)
                        }
                    >

                        <option value="">
                            Seleccione
                        </option>

                        <option value="1">Enero</option>
                        <option value="2">Febrero</option>
                        <option value="3">Marzo</option>
                        <option value="4">Abril</option>
                        <option value="5">Mayo</option>
                        <option value="6">Junio</option>
                        <option value="7">Julio</option>
                        <option value="8">Agosto</option>
                        <option value="9">Septiembre</option>
                        <option value="10">Octubre</option>
                        <option value="11">Noviembre</option>
                        <option value="12">Diciembre</option>

                    </select>

                </div>


                <div className="col-md-3">

                    <label className="form-label">
                        Año
                    </label>

                    <input
                        type="number"
                        className="form-control"
                        min="2020"
                        max="2050"
                        value={anio}
                        onChange={(e) =>
                            setAnio(e.target.value)
                        }
                    />

                </div>


                <div className="col-md-3 d-flex align-items-end">

                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={crearSeguimientoMes}
                    >

                        <i className="bi bi-plus-circle me-1"></i>

                        Crear nuevo mes

                    </button>

                </div>

            </div>

        </div>

    </div>

    )}



    {/* ==========================
        INFORMACIÓN GENERAL
    ========================== */}

    {seguimientoSeleccionado && (

        <div className="card mb-4">

            <div className="card-body">

                <div className="row">

                    <div className="col-md-3">

                        <strong>Programa</strong>
                        <br />

                        {seguimientoSeleccionado.program_name}

                    </div>

                    <div className="col-md-3">

                        <strong>Área</strong>
                        <br />

                        {seguimientoSeleccionado.area_name}

                    </div>

                    <div className="col-md-3">

                        <strong>Contratante</strong>
                        <br />

                        {seguimientoSeleccionado.contratante}

                    </div>

                    <div className="col-md-3">

                        <strong>Mes</strong>
                        <br />

                        {formatearMesAnio(
                            seguimientoSeleccionado.mes_año
                        )}

                    </div>

                </div>

            </div>

        </div>

    )}


      {/* ==========================
          MENSAJES
      ========================== */}

      {

        error &&

        <div className="alert alert-danger">
          {error}
        </div>

      }

      {

        success &&

        <div className="alert alert-success">
          {success}
        </div>

      }

    {seguimientos.length === 0 && (

        <div className="card mb-4">

            <div className="card-header">

                Crear seguimiento técnico

            </div>

            <div className="card-body">

                <div className="row">

                    <div className="col-md-4">

                        <label>Mes</label>
                        <select className="form-select"

                            value={mes}
                            onChange={(e)=>
                                setMes(
                                    e.target.value
                                )
                            }

                        >

                            <option value="">Seleccione</option>
                            <option value="1">Enero</option>
                            <option value="2">Febrero</option>
                            <option value="3">Marzo</option>
                            <option value="4">Abril</option>
                            <option value="5">Mayo</option>
                            <option value="6">Junio</option>
                            <option value="7">Julio</option>
                            <option value="8">Agosto</option>
                            <option value="9">Septiembre</option>
                            <option value="10">Octubre</option>
                            <option value="11">Noviembre</option>
                            <option value="12">Diciembre</option>

                        </select>

                    </div>

                    <div className="col-md-3">

                        <label>Año</label>

                        <input
                            type="number"
                            className="form-control"
                            min="2020"
                            max="2050"
                            value={anio}
                            onChange={(e)=>
                                setAnio(
                                    e.target.value
                                )

                            }

                        />

                    </div>

                    <div className="col-md-3 d-flex align-items-end">

                        <button className="btn btn-success" onClick={crearSeguimiento}>
                            Crear seguimiento
                        </button>

                    </div>

                </div>

            </div>

        </div>

        )

    }

      {/* ==========================
          BOTONES
      ========================== */}

      <div className="mb-3">

        <button className="btn btn-success me-2" onClick={agregarFila}>

          <i className="bi bi-plus-circle me-1"></i>
          Agregar indicador

        </button>

        <button className="btn btn-primary" onClick={guardarIndicadores}>

          <i className="bi bi-save me-1"></i>
          Guardar indicadores

        </button>

      </div>

      {/* ==========================
          TABLA
      ========================== */}

      <div className="table-responsive">

        <table className="table table-bordered align-middle">

          <thead className="table-secondary">

            <tr>

              <th style={{width:"25%"}}>Indicador</th>
              <th>Fórmula</th>
              <th>Dato referencia</th>
              <th>Dato mes</th>
              <th>Tipo</th>
              <th>Resultado</th>
              <th>Acción</th>

            </tr>

          </thead>

        <tbody>

            {

                indicadores.map((item, index) => (

                    <tr key={index}>

                        {/* INDICADOR */}

                        <td>

                            <input className="form-control"
                                value={item.indicador || ""}
                                onChange={(e) =>

                                    handleChange(
                                        index,
                                        "indicador",
                                        e.target.value
                                    )
                                }
                            />

                        </td>

                        {/* FORMULA */}

                        <td>

                            <input className="form-control"
                                value={item.formula || ""}

                                onChange={(e) =>
                                    handleChange(
                                        index,
                                        "formula",
                                        e.target.value
                                    )

                                }

                            />

                        </td>

                        {/* DATO REFERENCIA */}

                        <td>

                            <input
                                type="number"
                                className="form-control"
                                value={item.dato_referencia}
                                onChange={(e) =>
                                    handleChange(index, "dato_referencia", e.target.value)
                                }
                            />

                        </td>

                        {/* DATO MES */}

                        <td>

                            <input

                                type="number"
                                className="form-control"
                                value={item.dato_mes ?? ""}
                                onChange={(e) =>

                                    handleChange(
                                        index,
                                        "dato_mes",
                                        e.target.value
                                    )
                                }
                            />

                        </td>

                        {/* TIPO */}

                        <td>

                            <select className="form-select"

                                value={item.tipo || ""}
                                onChange={(e) =>
                                    handleChange(
                                        index,
                                        "tipo",
                                        e.target.value
                                    )
                                }

                            >

                                <option value="" hidden>Seleccione</option>
                                <option value="%">% </option>
                                <option value="#">#</option>

                            </select>

                        </td>

                        {/* RESULTADO */}

                        <td>

                            <input className="form-control"
                                value={
                                    item.tipo === "%"
                                        ? `${item.resultado ?? 0}%`
                                        : (item.resultado ?? 0)
                                    }
                                readOnly

                            />

                        </td>

                        {/* ELIMINAR */}

                        <td className="text-center">

                            <button className="btn btn-sm btn-danger" onClick={() =>eliminarFila(index)}>
                                <i className="bi bi-trash"></i>
                            </button>

                        </td>

                    </tr>

                ))

            }

        </tbody>

        </table>

      </div>

    </div>

  );

};

export default Seguimiento;
